import React from 'react'
import CreditCardDownForMaintenance from 'sprockets_react/job_wizards/components/credit_card/CreditCardDownForMaintenance'
import CreditCardForm from 'sprockets_react/job_wizards/components/credit_card/CreditCardForm'
import { Job } from 'sprockets_react/job_wizards/registries'
import amexImage from 'cc/amex.svg'
import mastercardImage from 'cc/mastercard.svg'
import visaImage from 'cc/visa.svg'

const CreditCardContainer = React.createClass({
 disclaimer: function() {
    return(
      <div className="bg-white-smoke mb32 credit-card-disclaimer">
        <div className="row">
          <div className="col-xs-12 p32">
            <div className="font-14 text-gray">
              By pressing 'Continue' you agree to our Terms & Conditions and acknowledge that your credit card will be debited for the Upgrades selected above
            </div>
          </div>
        </div>
      </div>
    )
  },

  render: function() {
    let defaultAction = `/products/jobs/${Job.Data.id}/upgrade`

    return(
      window.SS.payment_gateway_down_for_maintenance ?
      <CreditCardDownForMaintenance />
      :
      <div>
        <div className="bg-white credit-card-types">
          <div className="row">
            <div className="col-xs-6">
              <div className="font-16 bold mt16 mb16 card-detail-header">Card Details</div>
            </div>
            <div className="col-xs-6">
              <div className="cc-card-icon mt16 mb16 pull-right">
                <img src={amexImage} />
                <img src={mastercardImage} />
                <img src={visaImage} />
              </div>
            </div>
          </div>

          <div className="row pb16">
            <div className="col-xs-12 mb16">
              <div className="bg-white-smoke p16">
                <div className="cc-lock-icon ficon-SSL" />
                <div className="font-14 text-gray cc-text-icon">This is a secure 128-bit SSL encrypted payment.</div>
              </div>
            </div>
          </div>
        </div>

        <CreditCardForm
          action={this.props.action || defaultAction}
          formId={this.props.formId}
          hiddenFields={this.props.hiddenFields}
          submitButton={this.props.submitButton}
          disclaimer={this.disclaimer()}
          withExistingCard={this.props.withExistingCard}
          ccNumber={this.props.ccNumber}
        />
      </div> //wrapping div
    )
  }
})

export default CreditCardContainer
